import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const Admin = lazyLoad(
  () => import('./index'),
  module => module.default,
  {
    fallback: <LoadingIndicator />,
  },
);
